module.exports = __webpack_public_path__ + "img/V60.e9e7f70a.jpg";